export class LoadingDialogConstants {
  static readonly LOADER_STEP_TIME = 300;
  static readonly LOADER_STROKE_WIDTH = 5;
  static readonly LOADER_DIAMETER = 94;
  static readonly LOADER_MAX_PERCENT = 95;
}
